import React, { Component } from "react"
import { RouteComponentProps } from "react-router-dom"
import { connect } from "react-redux"
import { toast } from "react-toastify"
import { APIError } from "../api/ObservableFromFetch"
import { AppState } from "../AppState";
import { Action, Dispatch } from "redux";
import PageLoading from "../components/PageLoading"
import { EmbeddedOrderModeEnabled, GetSSOAction, SetEmbeddedOrderMode, SetSiteSearchMode, SetSSOAction, SetSSOPayload, SiteSearchModeEnabled } from "../storage/AuthToken"
import AuthService from "./AuthService"
import { ssoTokenLoginToWorkforce, WorkforceOneUserLogOut } from "../actions/WorkforceOneLoginActions"
import { SSOOrderRoute, SSOSiteSearchRoute, SSOGetAuthFormRoute } from "../config/Routes"

export interface SSOWorkforce1LoginProps { }
export interface SSOWorkforce1LoginAppStateProps {
  isLoggedIn: boolean
  isLoading: boolean
  userName?: string
}
export interface SSOWorkforce1LoginDispatchProps {
  login: (token: string, isSiteSearch: boolean, isEmbeddedOrder: boolean, action:string) => void
  logout: () => void
}

export interface SSOWorkforce1LoginState {
  spinnerMessage: string
}

export class SSOWorkforce1Login extends Component<SSOWorkforce1LoginProps & SSOWorkforce1LoginAppStateProps & SSOWorkforce1LoginDispatchProps & RouteComponentProps, SSOWorkforce1LoginState>{
  state: SSOWorkforce1LoginState = { spinnerMessage: "Authentication..." }
  token = ""
  base64String = ""

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.logout()
    }
    const searchParams = new URLSearchParams(this.props.location.search)
    this.base64String = searchParams.get("payload") || ""
    this.token = searchParams.get("token") || ""
    const provider = searchParams.get("provider") || undefined
    const siteSearch = searchParams.get("sitesearch") || false
    const embeddedOrder = searchParams.get("order") || false
    const action = searchParams.get("action") || ""
    if (this.token != "") {
      if (siteSearch) {
        SetSiteSearchMode()
      }
      if (embeddedOrder) {
        SetEmbeddedOrderMode()
      }
      SetSSOAction(action)
      this.props.login(this.token, !!siteSearch, !!embeddedOrder, action);
    }
    else {
      SetSSOPayload(this.base64String)
      this.signIn(provider)
    }
  }

  componentDidUpdate(prevProps: SSOWorkforce1LoginAppStateProps) {
    const isSiteSearch = SiteSearchModeEnabled()
    const isEmbeddedOrder = EmbeddedOrderModeEnabled()
    const action = GetSSOAction()
    if (this.props.isLoggedIn !== prevProps.isLoggedIn) {
      if (isSiteSearch) {
        this.props.history.push(SSOSiteSearchRoute)
      }
      if (isEmbeddedOrder) {
        this.props.history.push(SSOOrderRoute)
      }
      if (action === "getauthform") {
        this.props.history.push(SSOGetAuthFormRoute)
      }
    }
    if (!this.props.isLoading && prevProps.isLoading && !this.props.userName) {
      this.setState({spinnerMessage: 'Authentication error # 1'})
    }
  }

  signIn = (provider?: string) => {
    const authService = new AuthService()
    authService.signinRedirect(provider).catch(() => {
      this.setState({spinnerMessage: 'Authentication error # 2'})
    })
  }

  handleAPIError = (error: Error | APIError) => {
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  render() { return <>
    <PageLoading message={this.state.spinnerMessage} showNav={true} embedingMode={true}/>
  </>
  }
}

function mapStateToProps(state: AppState): SSOWorkforce1LoginAppStateProps {
  return {
    isLoggedIn: state.Workforce1State.isLoggedIn,
    isLoading: state.Workforce1State.isLoading,
    userName: state.Workforce1State.userName
  }
}

function mapDispatchProps(dispatch: Dispatch<Action>): SSOWorkforce1LoginDispatchProps {
  return {
    logout: () => (dispatch(WorkforceOneUserLogOut(true))),
    login: (token: string, isSiteSearch: boolean, isEmbeddedOrder: boolean, action:string) => (dispatch(ssoTokenLoginToWorkforce(token, isSiteSearch, isEmbeddedOrder, action))),
  }
}

export default connect<SSOWorkforce1LoginAppStateProps, SSOWorkforce1LoginDispatchProps, SSOWorkforce1LoginProps, AppState>(
  mapStateToProps, mapDispatchProps)(SSOWorkforce1Login)
